module.exports = __webpack_public_path__ + "img/sj.6ad53928.svg";